import React from 'react';
import './Footer.css'; //styling sheet
import { MdEmail } from "react-icons/md"; //mail icon
import { FaSlack, FaMailchimp, FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa"; //social media icons

function Footer() {
  return (
    <footer>
      <section id="contact">
        
        {/* Title */}
        <h2>Contact Us!</h2> 

        {/* Icons & Social Account links*/}
        <ul className="contact-icons">
          <li className="email"><a href="mailto:ohanauw@uw.edu"><MdEmail /></a></li>
          <li className="slack"><a href="https://huihoalohaulana.slack.com/join/shared_invite/zt-whuf2ioj-q3rYxaDqbaji2NoDtKZjGg#/shared-invite/email"><FaSlack /></a></li>
          <li className="mailchimp"><a href="https://washington.us13.list-manage.com/subscribe?u=155cc7ce50de9517d10acd496&id=a5b122d84a"><FaMailchimp /></a></li>
          <li className="ig"><a href="https://www.instagram.com/hawaiiclubatuw/"><FaInstagram /></a></li>
          <li className="tt"><a href="https://www.tiktok.com/@hawaiiclubatuw"><FaTiktok /></a></li>
          <li className="fb"><a href="https://www.facebook.com/groups/uwhawaiiclub/"><FaFacebook /></a></li>
        </ul>

        {/* Addresses */}
        <div className="contact-details">
          <p>
            <strong>Address</strong><br />
            Hui Hoaloha Ulana<br />
            SAO Box 115<br />
            UW Box 352238<br />
            Seattle, WA 98195-2238
          </p>
          <p>
            <strong>Student Activities Office</strong><br />
            HUB 207<br />
            Box 352238<br />
            Seattle, WA 98195
          </p>
        </div>

        {/* Copyright (should automatically update year)*/}
        <p id="copyright">&copy; {new Date().getFullYear()} Hui Hoaloha Ulana at the University of Washington Seattle</p>
      </section>
    </footer>
  );
}

export default Footer;
